import React from 'react';
import ValidatorSummary, { IValidatorDecisionConfig } from 'components/ValidatorSummary';
import { ConceptLinkerValidatorItemStatus, AsyncTaskStatus } from 'constants/conceptLinkerValidatorStatus';
import ConceptLinkerValidatorItemsModel from 'models/ConceptLinkerValidatorItemsModel';
import ConceptCardHover from 'components/common/ConceptCardHover';

interface IProps {
  itemsModel: ConceptLinkerValidatorItemsModel;
  onFilterChange: (type: 'status' | 'decision' | 'change-concept' | 'cannot-link', value: string) => void;
  activeFilter: { type: 'status' | 'decision' | 'change-concept' | 'cannot-link'; value: string } | null;
  onClearFilter: () => void;
  courseId?: number;
}

const ConceptLinkerValidatorSummary: React.FC<IProps> = ({
  itemsModel,
  onFilterChange,
  activeFilter,
  onClearFilter,
  courseId = 0,
}) => {
  const decisions: IValidatorDecisionConfig[] = [
    { key: 'keep', label: 'Keep', color: '#66BB6A' },
    { key: 'change', label: 'Change', color: '#42A5F5' },
    { key: 'unlink', label: 'Unlink', color: '#EF5350' },
  ];

  const statusConfig = {
    PENDING: ConceptLinkerValidatorItemStatus.PENDING,
    NEEDS_USER_REVIEW: ConceptLinkerValidatorItemStatus.NEEDS_USER_REVIEW,
    DONE: ConceptLinkerValidatorItemStatus.DONE,
  };

  const asyncTaskStatusConfig = {
    FAILED: AsyncTaskStatus.FAILED,
    DEAD_LETTER: AsyncTaskStatus.DEAD_LETTER,
  };

  // Adapter for filter change to match original signature
  const handleFilterChange = (type: string, value: string) => {
    onFilterChange(type as any, value);
  };

  return (
    <ValidatorSummary
      items={(itemsModel.gridData as any[]) || []}
      decisions={decisions}
      statusConfig={statusConfig}
      asyncTaskStatus={asyncTaskStatusConfig}
      onFilterChange={handleFilterChange}
      activeFilter={activeFilter}
      onClearFilter={onClearFilter}
      enableChangeGrouping={true}
      changeGroupComponent={ConceptCardHover}
      courseId={courseId}
      customFeatures={{ cannotLink: true }}
      colors={{
        processing: '#9C27B0',
        review: '#FFA726',
        error: '#E53935',
        cannotLink: '#FF7043',
      }}
    />
  );
};

export default ConceptLinkerValidatorSummary;